<template>
  <div>
    <div class="display-value mediumShadow mediumRoundAngles" ref="searchInput" :style="'border-color:'+color">
      <div class="value-text">
        <i class="fas fa-search"></i>
        <input class="value-text" v-model="searchedText" placeholder="Rechercher une série" @focus="toggleOptions()"
               @blur="toggleOptions()">
        <i class="far fa-times-circle" v-if="searchedText != ''" @click="closeSearch" style="cursor: pointer;"></i>
      </div>
    </div>
    <!--
    <ul tabindex="0" class="select-container" ref="selectContainer" :style="'border-color:'+color">
        <li class="select-option" v-for="(option, key) in sortedShowsFound" v-if="key<10" @mousedown="selected(option, option.id)">
            <div class="select-option line-clamp clamp1">{{option.english_title}}</div>
        </li>
    </ul>
    -->
  </div>
</template>

<script>
import compareStrings from '@/strikeamatch'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "search",
  props: ['showsList', 'seasonsIndexes', 'seasonsList', 'color'],

  created() {

  },

  data() {
    return {
      originalSeasonsIndex: [],
      isOpen: false,
      searchedText: "",
      sortedShowsFound: []
    }
  },
  beforeDestroy: function () {
    this.searchedText = "";
    this.seasonsIndexes.sort(function (a, b) {
          return a.order - b.order
        }
    );
    //this.set_showsData(this.sortedShowsFound)
  },
  watch: {
    searchedText: function (newval, oldval) {
      //this.sortedShowsFound = [];
      if (newval !== "") {
        this.seasonsIndexes.forEach((item) => {
              this.showsList[this.seasonsList[item.id].show_id].levdist = Math.max(
                  compareStrings(this.showsList[this.seasonsList[item.id].show_id].english_title, newval),
                  compareStrings(this.showsList[this.seasonsList[item.id].show_id].french_title, newval))
        }
        );
        this.seasonsIndexes.sort((a, b) => {
          return this.showsList[this.seasonsList[b.id].show_id].levdist - this.showsList[this.seasonsList[a.id].show_id].levdist
        });
      } else {
        this.seasonsIndexes.sort(function (a, b) {
              return a.order - b.order
            }
        );
      }
      if ((oldval === "" && newval !== "") || oldval !== newval) {
        this.$emit('searchingStart');
        if(!this.$isDebug) {
          fbq('track', 'Search');
        }
      }

      // this.set_showsData(this.sortedShowsFound)
    }
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  methods: {
    ...mapActions('global', [
      'set_seasonsIndex'
    ]),
    closeSearch: function () {
      this.searchedText = '';
    },
    showBar: function () {
      setTimeout(() => {
        this.showVerticalLine = true;
        this.hideBar()
      }, 600);

    },
    hideBar: function () {
      setTimeout(() => {
        this.showVerticalLine = false;
        this.showBar()
      }, 800);

    },
    toggleOptions: function () {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        //this.$refs.selectContainer.style.visibility = 'visible';
        //this.searchedText = "";
        this.$refs.searchInput.focus();
      } else {
        this.$refs.searchInput.blur();
        //this.searchedText = "";
        //this.$refs.selectContainer.style.visibility = 'hidden';


      }
    },
    selected: function (val, key) {
      this.searchedText = "";
      this.$emit('selected', key);
    }
  }
}
</script>

<style scoped>
.display-value {
  height: 2vw;
  width: 100%;
  display: flex;
  background: #eeeeee80;
}

.display-value:hover {
  color: #f91e48;
}

.value-text:focus {
  outline: none;
}

.value-text {
  display: flex;
  padding-left: 0.5vw;
  align-items: center;
  color: #222;
  width: calc(100% - 1vw);
}

input.value-text {
  background: transparent;
  display: flex;
  padding-left: 0.5vw;
  align-items: center;
  color: #222;
  width: 100%;
  border: 0;
  font-size: 90%;
}

.arrow {
  left: 2.5vw;
  top: 0.9vw;
  position: absolute;
}

.arrow.arrow-up {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid black;
}

.arrow.arrow-down {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid black;
}

.select-container {
  width: 12.5vw;
  padding: 0;
  position: absolute;
  visibility: hidden;
  margin: 0;
  height: fit-content;
  border: 1px solid #222;
  list-style-type: none;
  display: block;
  background: #020202;
}

.select-container:focus {
  outline: none;
}

.select-option {
  height: 1.5vw;
  display: flex;
  padding-left: 0.5vw;
  align-items: left;
  justify-items: center;
  color: #eeeeee;
  font-size: 0.9vw;
}

.select-option:hover {
  background: #555;
  cursor: pointer;
}

.line-clamp {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.clamp1 {
  -webkit-line-clamp: 1;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #393939;
  opacity: 1; /* Firefox */
}

@media screen and (max-device-width: 767px) {
  .display-value {
    height: 8vw;
  }

  .value-text {
    padding-left: 2vw;
    width: calc(100% - 4vw);
  }

  input.value-text {
    padding-left: 2vw;
  }

  .select-option {
    padding-left: 2vw;
  }
}

</style>